import user from "./user";
import order from "./order";
import activity from "./activity";
import admin from "./admin";
import store from "./store";
import points from "./points";

export default [...user, ...order, ...activity, ...admin, ...store, ...points];
